import { cn } from "@punchup/utils/cn";

export default function PageTitleHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h1 className={cn("text-4xl", className)}>{children}</h1>;
}
